import React, { useMemo } from 'react';
import { rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';

import ActiveSurgeonCard from './ActiveSurgeonCard';

const ActiveSurgeonStage = (props) => {
  const {
    stage,
    leads = [],
    surgeons = [],
    specialities = [],
    cases = [],
    onLeadClick,
    tenantColor,
    isLast,
    surgeonRanking,
  } = props;

  const { setNodeRef } = useDroppable({
    id: stage.id,
  });

  const surgeonsNumber = useMemo(() => {
    const arr = [];
    leads.forEach((l) => {
      if (!arr.includes(l.surgeon)) {
        arr.push(l.surgeon)
      }
    });
    return arr.length;
  }, [leads]);

  return (
    <div className="sales-page__stage-item" ref={setNodeRef} style={isLast ? { marginRight: 0 } : {}}>
      <div className='stage-item-title__container'>
        <div className="font-bold font-size-bg">{stage.title}</div>
        <div className="font-size-sm">{stage.description}</div>
        <div className="m-t-sm secondary">
          {`${surgeonsNumber} Surgeon${surgeonsNumber === 1 ? '' : 's'}`}
        </div>
      </div>

      <div className='stage-item__leads-list'>
        <SortableContext
          items={leads.map((lead) => lead.id)}
          strategy={rectSortingStrategy}
        >
          {leads?.map((lead) => (
            <ActiveSurgeonCard
              key={lead.id}
              id={lead.id}
              lead={lead}
              surgeons={surgeons}
              onClick={() => onLeadClick(lead)}
              tenantColor={tenantColor}
              surgeonRanking={surgeonRanking}
              specialities={specialities}
              cases={cases}
              caseVolumeMin={stage.caseVolumeMin}
              caseVolumeMax={stage.caseVolumeMax}
            />
          ))}
        </SortableContext>
      </div>
    </div>
  )
};

export default ActiveSurgeonStage;